import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthServices } from "../services/AuthServices";
import useUpdateOnboardingStatus from "../../../utils/hooks/useUpdateOnboardingStatus";

const VerifyId = ({ setStep }) => {
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const navigate = useNavigate();
  const updateOnboardingStatus = useUpdateOnboardingStatus();

  const simulateUpload = () => {
    setProgress(0);
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 10;
      });
    }, 200);
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      simulateUpload();
    }
  };

  const handleRemoveFile = () => {
    setFile(null);
    setProgress(0);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) return alert("Please upload an ID image before continuing.");

    const formData = new FormData();
    formData.append("images", file);

    try {
      const response = await AuthServices.updateID(formData);
      if (response.data?.status === 401) {
        navigate("/");
        return;
      }

      if (!response.success) {
        console.log("ID upload failed:", response);
        return;
      }

      const updated = await updateOnboardingStatus("verifyId");
      if (!updated) throw new Error("Onboarding status update failed");

      setStep(6);
    } catch (err) {
      console.error(err);
      alert("Something went wrong while verifying your ID.");
    }
  };

  return (
    <div className="verify-container">
      <div className="verify-card">
        <div className="verify-header">
          <div className="verify-icon">
            <span>📷</span>
          </div>
          <h2>Verify your ID</h2>
          <p>
            At Shophr, we collaborate with coolID verification to securely
            confirm your identity, providing peace of mind as you set up your
            account.
          </p>
        </div>

        <div
          className="upload-box"
          onClick={() => document.getElementById("fileInput").click()}
        >
          <input
            id="fileInput"
            type="file"
            accept=".jpg,.jpeg,.png"
            className="hidden-input"
            onChange={handleFileChange}
          />
          <p className="upload-link">Click to upload</p>
          <p className="upload-sub">or drag and drop</p>
          <p className="upload-hint">JPG (max. 800x400px)</p>
        </div>

        {file && (
          <div className="file-box">
            <div className="file-info">
              <div className="file-type">
                {file.name.split(".").pop().toUpperCase()}
              </div>
              <div>
                <p className="file-name">{file.name}</p>
                <p className="file-size">{(file.size / 1024).toFixed(2)} KB</p>
                <div className="progress-bar">
                  <div
                    className="progress-fill"
                    style={{ width: `${progress}%` }}
                  />
                </div>
              </div>
            </div>
            <button onClick={handleRemoveFile} className="remove-btn">
              🗑️
            </button>
          </div>
        )}

        <button
          onClick={handleSubmit}
          disabled={progress < 100}
          className={`continue-btn ${progress === 100 ? "active" : ""}`}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default VerifyId;
